// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive table styles for SafTable */
.table-container {
  width: 100%;
  overflow-x: auto;
  margin: 0;
  padding: 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Content container for components to respond to sidebar toggle */
.content-container {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Responsive table styles for SafTable */
.mytable {
  width: 100% !important;
  min-width: 100% !important;
  table-layout: auto;
  border-collapse: collapse;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.mytable th,
.mytable td {
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  padding: 12px 8px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Ensure SafTable takes full width */
saf-table {
  width: 100% !important;
  display: block !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

saf-table table {
  width: 100% !important;
  min-width: 100% !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Handle sidebar toggle state changes */
body.sidebar-hidden .content-container {
  width: 100%;
  max-width: 100%;
}

body.sidebar-hidden .table-container {
  width: 100%;
  max-width: 100%;
}

body.sidebar-hidden .mytable {
  width: 100% !important;
  min-width: 100% !important;
}

body.sidebar-hidden saf-table {
  width: 100% !important;
}

body.sidebar-hidden saf-table table {
  width: 100% !important;
  min-width: 100% !important;
}

/* Mobile table adjustments */
@media (max-width: 767px) {
  .mytable {
    font-size: 0.875rem;
  }

  .mytable th,
  .mytable td {
    padding: 8px 4px;
    white-space: normal;
    word-break: break-word;
  }
}

/* Tablet table adjustments */
@media (min-width: 768px) and (max-width: 1023px) {
  .mytable th,
  .mytable td {
    padding: 10px 6px;
    white-space: normal;
    word-break: break-word;
  }
}

/* Desktop table adjustments */
@media (min-width: 1024px) {
  .mytable th,
  .mytable td {
    padding: 12px 8px;
    white-space: normal;
    word-break: break-word;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/table-responsive.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,iDAAiD;AACnD;;AAEA,kEAAkE;AAClE;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA,yCAAyC;AACzC;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;EACtB,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA,6BAA6B;AAC7B;EACE;;IAEE,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA,8BAA8B;AAC9B;EACE;;IAEE,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;EACxB;AACF","sourcesContent":["/* Responsive table styles for SafTable */\n.table-container {\n  width: 100%;\n  overflow-x: auto;\n  margin: 0;\n  padding: 0;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Content container for components to respond to sidebar toggle */\n.content-container {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Responsive table styles for SafTable */\n.mytable {\n  width: 100% !important;\n  min-width: 100% !important;\n  table-layout: auto;\n  border-collapse: collapse;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.mytable th,\n.mytable td {\n  white-space: normal;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  padding: 12px 8px;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Ensure SafTable takes full width */\nsaf-table {\n  width: 100% !important;\n  display: block !important;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\nsaf-table table {\n  width: 100% !important;\n  min-width: 100% !important;\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Handle sidebar toggle state changes */\nbody.sidebar-hidden .content-container {\n  width: 100%;\n  max-width: 100%;\n}\n\nbody.sidebar-hidden .table-container {\n  width: 100%;\n  max-width: 100%;\n}\n\nbody.sidebar-hidden .mytable {\n  width: 100% !important;\n  min-width: 100% !important;\n}\n\nbody.sidebar-hidden saf-table {\n  width: 100% !important;\n}\n\nbody.sidebar-hidden saf-table table {\n  width: 100% !important;\n  min-width: 100% !important;\n}\n\n/* Mobile table adjustments */\n@media (max-width: 767px) {\n  .mytable {\n    font-size: 0.875rem;\n  }\n\n  .mytable th,\n  .mytable td {\n    padding: 8px 4px;\n    white-space: normal;\n    word-break: break-word;\n  }\n}\n\n/* Tablet table adjustments */\n@media (min-width: 768px) and (max-width: 1023px) {\n  .mytable th,\n  .mytable td {\n    padding: 10px 6px;\n    white-space: normal;\n    word-break: break-word;\n  }\n}\n\n/* Desktop table adjustments */\n@media (min-width: 1024px) {\n  .mytable th,\n  .mytable td {\n    padding: 12px 8px;\n    white-space: normal;\n    word-break: break-word;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
